import { setupAuthentication } from '../store/auth/action-creators';
export const setupAuth = store => {
  return store.dispatch(setupAuthentication());
};